// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"ScreenContainer_rowContainer__2NAjl","colContainer":"ScreenContainer_colContainer__NGsIe"};